var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.viewBackupShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "viewSourceFile" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("\n             Original\n            "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viewSourceFile-body" },
            _vm._l(_vm.sourceData.data, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "backup-list",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toSource(item)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "item-formicon small-file folder-small"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "backup-url",
                      staticStyle: {
                        marginLeft: "10px",
                        float: "left",
                        cursor: "pointer"
                      },
                      attrs: { title: item.path }
                    },
                    [_vm._v(_vm._s(item.path))]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticStyle: {
                float: "right",
                marginRight: "20Px",
                width: "100Px",
                marginTop: "5px"
              },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v("  " + _vm._s(_vm.$t("language.common.ok")))]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e0dc12a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e0dc12a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/restore_aim_more_popup.vue
// module id = null
// module chunks = 